(function () {
    'use strict';
    var m = angular.module('profiles');
    m.factory('allUserEmailsLogic', ["emailDao", "simpleSortableLogicCore", "fileDao", function (emailDao, simpleSortableLogicCore, fileDao) {
        return function ($scope, logic) {
            if ($scope.model.type === 'data-table') {
                $scope.model.wrapper.title = 'All emails from/to/cc ' + logic.userId;
                return simpleSortableLogicCore($scope, logic, {
                    retrieve: function () {
                        return emailDao.allUserEmails($scope.model.columns, logic.userId, logic.direction, {
                            highlightUserEmailConverter: function (text) {
                                if (!text || !logic.userId || !logic.userId.length || !text.length) {
                                    return text;
                                }
                                if (text === logic.userId || text.length > logic.userId.length + 1 && text.slice(-(logic.userId.length + 1)) === ' ' + logic.userId) {
                                    return '#' + JSON.stringify({
                                        display: 'text',
                                        'class': 'highlighted-user',
                                        text: text
                                    });
                                }
                                return text;
                            }
                        });
                    }
                });
            }
            function showWidget(setIdx) {
                _($scope.model.widgets[0].lines).each(function (line, idx) {
                    line['class'].active = setIdx - 1 === idx;
                });
                _($scope.model.widgets).each(function (widget, idx) {
                    if (idx < 1) {
                        return;
                    }
                    widget.style.display = idx === setIdx ? 'block' : 'none';
                });
            }
            var outgoingLabel = 'OUTGOING';
            var incomingLabel = 'INCOMING';
            var tablesOptions = _($scope.model).pick('columns', 'options', 'class', 'logic');
            tablesOptions.style = {
                height: 'calc(100vh - 251px)',
                overflow: 'auto'
            };
            _(tablesOptions.columns).each(function (column) {
                if (column.converter === 'userWithEmail') {
                    column.converterArgs.highlightId = logic.userId;
                    return;
                }
                if (column.converter === 'listConverter' && column.converterArgs.itemConverter) {
                    column.converterArgs.itemConverterArgs.highlightId = logic.userId;
                }
            });
            if ($scope.model.type === 'multi-widget') {
                $scope.infoWidget = {
                    'type': 'info',
                    'class': 'all-user-emails-info',
                    'wrapper': { 'type': 'none' },
                    'lines': [
                        {
                            'text': 'Ougoing',
                            'class': {
                                'active': true,
                                'selector': true
                            },
                            execute: function () {
                                showWidget(1);
                            }
                        },
                        {
                            'text': 'Incoming',
                            'class': {
                                'active': false,
                                'selector': true
                            },
                            execute: function () {
                                showWidget(2);
                            }
                        }
                    ]
                };
                $scope.outgoingWidget = $.extend(true, angular.copy(tablesOptions), {
                    logic: {
                        direction: 'outgoing',
                        updateTick: null,
                        name: 'allUserEmailsLogic'
                    },
                    type: 'data-table',
                    'wrapper': { 'type': 'none' },
                    style: {}
                });
                $scope.incomingWidget = $.extend(true, angular.copy(tablesOptions), {
                    logic: {
                        direction: 'incoming',
                        updateTick: null,
                        name: 'allUserEmailsLogic'
                    },
                    type: 'data-table',
                    'wrapper': { 'type': 'none' },
                    style: { display: 'none' }
                });
                $scope.model.widgets = [
                    $scope.infoWidget,
                    $scope.outgoingWidget,
                    $scope.incomingWidget
                ];
            }
            if (logic.userEntityType && logic.emailField) {
                fileDao.entityInfo(logic.userEntityType, logic.userId).then(function (response) {
                    if (response.data[logic.emailField]) {
                        incomingLabel = 'To/Cc ' + '#' + JSON.stringify({
                            display: 'text',
                            text: response.data[logic.emailField],
                            'class': 'darker'
                        });
                        outgoingLabel = 'From ' + '#' + JSON.stringify({
                            display: 'text',
                            text: response.data[logic.emailField],
                            'class': 'darker'
                        });
                    }
                });
                updateInfoLabels();
            }
            function updateInfoLabels() {
                var outLine = $scope.model.widgets[0].lines[0];
                var inLine = $scope.model.widgets[0].lines[1];
                if ($scope.outgoingWidget.wrapper.isLoading) {
                    outLine.text = '#' + JSON.stringify({
                        display: 'text',
                        text: '',
                        'class': 'fa fa-spinner fa-pulse'
                    }) + ' ' + outgoingLabel;
                } else {
                    outLine.text = '#' + JSON.stringify({
                        display: 'text',
                        text: $scope.outgoingWidget.totalRows || 0,
                        'class': 'darker'
                    }) + ' ' + outgoingLabel;
                }
                if ($scope.incomingWidget.wrapper.isLoading) {
                    inLine.text = '#' + JSON.stringify({
                        display: 'text',
                        text: '',
                        'class': 'fa fa-spinner fa-pulse'
                    }) + ' ' + incomingLabel;
                } else {
                    inLine.text = '#' + JSON.stringify({
                        display: 'text',
                        text: $scope.incomingWidget.totalRows || 0,
                        'class': 'darker'
                    }) + ' ' + incomingLabel;
                }
            }
            var outgoingWatch = $scope.$watch('outgoingWidget.wrapper.isLoading', function (isLoading) {
                updateInfoLabels();
            });
            var incomingWatch = $scope.$watch('model.widgets[2].wrapper.isLoading', function (isLoading) {
                updateInfoLabels();
            });
            return function () {
                outgoingWatch();
                incomingWatch();
            };
        };
    }]);
}());